import * as R from 'ramda';
import React from 'react';
import {defer} from 'rxjs';

import {translate} from 'iss/strings';
import {getQuestionGroups} from 'iss/service/QuestionService';
import subscribeTo from 'iss/utils/subscriptionUtils';
import {Button, EditButton, NewButton} from 'iss/widgets/Buttons';
import {RestResultMessage, SuccessBox} from 'iss/widgets/MessageBox';

const QuestionGroupList = subscribeTo(defer(getQuestionGroups), 'groups', function QuestionGroupList({groups}) {

  const showSuccessMessage = window.location.search.indexOf("success=true") != -1;
  const showDeleteMessage = window.location.search.indexOf("deleteSuccess=true") != -1;

  function getRow(group) {
    return <tr key={group.id} data-group-id={group.id}>
      <td className="group-description">{group.description}</td>
      <td>
        <EditButton className={"modify-group"}
          id={"modify-group-"+group.id}
          link={"/question-group/"+group.id}
          alt={translate('questionGroupList.editGroupTooltip')}
          />
      </td>
    </tr>;
  }

  return <div>
    <SuccessBox id="submitSuccess" message={showSuccessMessage ? translate('common.savedSuccessfully') : null} />
    <SuccessBox id="deleteSuccess" message={showDeleteMessage ? translate('common.deletedSuccessfully') : null} />
    <h1>{translate('questionGroupList.title')}</h1>
    <Button id="to-question-list" text={translate('questionGroupList.backToQuestionList')} link="/questions" />
    <table className="table table-striped">
      <thead>
        <tr>
          <th>{translate('domain.questionGroup.groupDescription')}</th>
          <th>{translate('common.editOrView')}</th>
        </tr>
      </thead>
      <tbody>
        {R.defaultTo([], groups).map(getRow)}
      </tbody>

    </table>
    <NewButton id="new-group" link="/question-groups/new" text={translate('questionGroupList.newGroup')} />
  </div>;
}, ({error}) => <RestResultMessage id="errorMessage" result={error} />);

export default QuestionGroupList;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/QuestionGroupList.jsx